import { gql } from "@apollo/client";

export const GET_BOOKINGS = gql`
    query CalendarGraphQL(
        $startDate:String!
        $endDate:String!
        $stakeholderAndVehicleCenterInputs: [StakeholderAndVehicleCenterInput!]!
        $vehicleSearchTerm:String
        $filterInput: GetCalendarRowFilterInput
        $first:Int
        $after:Cursor
    ) {
        getCalendarRows(input:{
            startDate: $startDate
            endDate: $endDate
            stakeholderAndVehicleCenterInputs: $stakeholderAndVehicleCenterInputs
            vehicleSearchTerm: $vehicleSearchTerm
            filterInput: $filterInput
            first: $first
            after: $after
        }) {
            calendarRows {
                vehicle {
                    id
                    year
                    make
                    modelName
                    trim
                    vin
                    status
                    sourceVehicleId
                    photoUrl
                },
                bookings {
                    id
                    vmhId
                    shId
                    userId
                    profileId
                    vehicleId
                    scheduledReleasedAt
                    scheduledReturnedAt
                    actualReturnedAt
                    sourceBookingId
                    sourceVehicleId
                    type
                    status
                    usageType
                    releasedTo
                },
                vehicleManagementHub {
                    vmhId
                    shId
                    name
                    city
                    turnPreDays
                    turnPreHours
                    turnPostDays
                    turnPostHours
                }
            },
            metaData {
                first
                nextCursor
            }
        }
    }
`;

export const GET_PENDING_BOOKINGS = gql`
    query PendingBookingsGraphQL($stakeholderAndVehicleCenterInputs: [StakeholderAndVehicleCenterInput!]!) {
        getPendingBookings(input: {
            stakeholderAndVehicleCenterInputs: $stakeholderAndVehicleCenterInputs
        }) {
            bookings {
                id
                releasedTo
                scheduledReleasedAt
                scheduledReturnedAt
                BOOK_ID: sourceBookingId
                status
                vehicle {
                    id
                    displayName
                    photoUrl
                    vin
                    V_ID: sourceVehicleId
                    stakeholder: stakeholderId
                    vmh: vehicleManagementHubId
                }
            }
        }
    }
`;

export const GET_VEHICLE_BOOKINGS = gql`
    query GetVehicleBookings(
        $stakeholderAndVehicleCenterInputs: [StakeholderAndVehicleCenterInput!]!
        $vehicleId: Int!
        $releasedSince: String
        $first: Int
        $after: Cursor
    ) {
        getVehicleBookings(input: {
            stakeholderAndVehicleCenterInputs: $stakeholderAndVehicleCenterInputs
            vehicleId: $vehicleId
            releasedSince: $releasedSince
            first: $first
            after: $after
        }) {
            bookings {
                id
                sourceBookingId
                sourceVehicleId
                vmhId
                shId
                oemId
                profileId
                userId
                scheduledReleasedAt
                scheduledReturnedAt
                actualReleasedAt
                actualReturnedAt
                type
                status
                usageType
                prepareStatus
                releasingAddress
                returningAddress
                releasedTo
                releasedBy
                returnedBy
                closedBy
                deniedNotes
                serviceBookingPurpose
                specialRequestRemark
                vehicleConditionalSnapshots {
                    id
                    type
                    fuelLevel
                    isDamaged
                    odometer
                    damagedNotes
                    bookingId
                }
            }
        }
    }
`;

export const GET_BOOKING_BY_SOURCE_ID = gql`
    query GetBookingBySourceBookingId($sourceBookingId: Int!) {
        getBookingBySourceBookingId(sourceBookingId: $sourceBookingId) {
            id
            vehicleId
            profileId
            releasedTo
            scheduledReleasedAt
            scheduledReturnedAt
            type
            usageType
            userId
            status
        }
    }
`;
